import * as React from "react";

export const SvgPlusOutline = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
		<path
			fill="#404040"
			stroke="#404040"
			strokeWidth={0.3}
			d="M12.038 6.44h-4.48V1.96a.56.56 0 0 0-1.12 0v4.48h-4.48a.56.56 0 0 0 0 1.12h4.48v4.48a.56.56 0 0 0 1.12 0V7.56h4.48a.56.56 0 0 0 0-1.12Z"
		/>
	</svg>
);
